import { gql } from "@apollo/client";

export const GET_APPLICATIONS = gql`
  query GetApplications($stepType: FORM_TYPE!) {
    getApplications(stepType: $stepType) {
      id
      firstName
      lastName
      phoneNumber
      secondaryPhoneNumber
      optionalPhoneNumber
      state {
        name
      }
      cities {
        name
      }
      email
      neighborhood
      helpType
      step
      rumvNumber
      created
      modified
    }
  }
`;
